import smooth from '../images/_/smooth inc.png'
import direct from '../images/direct home.png'
import loadhaul from '../images/Component 4.png';
import dessbell from '../images/dessbell.png';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';




const Works = () => {

  let p = '< p >';
  let pc = '< /p >';
  return (
     <div>
             <Navbar/>
            <section className="works">
           <div className="container">
                       <div className="row">
                                  <div className="col-lg-6 col-md-6">
                                                <h2>latest works</h2>
                                                <p> <span> {p} </span> perfect solutions for digital questions  <span> {pc} </span></p>
                                                <div className="github-project1">
                                                    <img src={smooth} alt="smoothinc" className="img-fluid"/>
                                                    <h2><a href="https://www.figma.com/file/GUPAPL6HsvhzdCkjK53GgD/Untitled?node-id=0%3A1&t=tuC3AWGpTJPi5GQg-1" className="effect-5"><h3>figma</h3></a></h2>

                                                </div>
                                                
                                                <div className='github-project4'>
                                                  <img src={dessbell} alt="dessbell" className='img-fluid'/>
                                                  <h2><a href="https://github.com/tristenswisss/dessbell.git" className="effect-5"><h3>github</h3></a></h2>

                                                </div>
                                                

                                  </div>

                                  <div className="col-lg-6 col-md-6">
                                    <div className="otherWorks">
                                        <div className="github-project2">
                                            <img src={direct} alt="directhome" className="img-fluid"/>
                                        <h2><a href="https://github.com/tristenswisss/direct-home-mortgages.git" className="effect-5"><h3>github</h3></a></h2>

                                        </div>
                                        
                                        <div className="github-project3">
                                            <img src={loadhaul} alt="loadhaul" className="img-fluid"/>
                                            <h2><a href="https://github.com/tristenswisss/load-haul.git" className="effect-5"><h3>github</h3></a></h2>

                                        </div>
                                        
                                    </div>

                                    
                                  </div>


                       </div>
           </div>
    </section>
    <Footer/>
     </div>
  );
};
export default Works;
